import { Injectable } from '@angular/core';

@Injectable()
export class CurrencyMaskService {
  private prefix: string;
  private decimalSeparator: string;
  private thousandsSeparator: string;
  constructor() {
    this.prefix = '';
    this.decimalSeparator = '.';
    this.thousandsSeparator = ',';
  }

  format(
    value: any,
    decimalPrecision: number = 2,
    allowNegative = false,
    defaultValue: any = undefined
  ): string {
    if (value === undefined || value === '') {
      if (defaultValue === undefined) {
        return '';
      } else value = defaultValue;
    }
    if (allowNegative) {
      value = value.toString();
      if (value.startsWith('(') || value.startsWith('-')) {
        value = `-${value.substr(1, value.length).replace(/\(|\)|\$|\-/g, '')}`;
      } else {
        value = value.replace(/\(|\)|\$|\-/g, '');
      }
    }
    let [integer, fraction = ''] = (value || '')
      .toString()
      .split(this.decimalSeparator);
    fraction =
      decimalPrecision > 0
        ? this.decimalSeparator +
          `${fraction}00000000`.substring(0, decimalPrecision)
        : '';
    integer = integer.replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    // If user types .xx we can display 0.xx
    if (integer === '') {
      integer = '0';
    } else if (integer.startsWith('$')) {
      // If there are multiple transforms, remove the previous dollar sign (blur and change at the same time)
      integer = integer.substr(1, integer.length);
    } else if (allowNegative && integer.startsWith('-')) {
      // If user inputs negative number set to paranthesis format
      integer = integer.substr(1, integer.length);
      return `(${this.prefix}${integer}${fraction})`;
    }
    return this.prefix + integer + fraction;
  }

  parse(value: string, decimalPrecision: number = 2, allowNegative = false) {
    let integer = '0';
    let fraction = '00';
    if (value) {
      const valueParts = `${value}`.split(this.decimalSeparator);
      if (valueParts.length > 0) integer = valueParts[0];
      if (valueParts.length > 1) fraction = valueParts[1];
    }

    integer = integer.replace(new RegExp(/[^\d\.]/, 'g'), '');
    fraction = fraction.replace(new RegExp(/[^\d\.]/, 'g'), '');

    if (decimalPrecision > 0) {
      if (fraction && !isNaN(+fraction))
      {
        if(fraction.length > decimalPrecision) {
          const text = this.decimalSeparator + fraction;
          let num = Number(text).toFixed(decimalPrecision); //round
          fraction = num.toString();
          fraction = fraction.substring(1);
        }
        else {
          fraction = this.decimalSeparator + fraction;
        }
        
        // fraction =
        //   fraction.length > decimalPrecision
        //     ? this.decimalSeparator + fraction.substring(0, decimalPrecision)
        //     : this.decimalSeparator + fraction;
      }      
      else if (value && value.endsWith(this.decimalSeparator))
        fraction = this.decimalSeparator;
      else fraction = '';
    }
    else fraction = '';

    if (value && allowNegative && ((value.toString().startsWith('(') && value.toString().endsWith(')')) || value.toString().startsWith('-'))) {
      return (-1 * parseFloat(integer + fraction)).toString();
    }
    else {
      return integer + fraction;
    }
  }
}
